"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isPlainObject = require("lodash.isplainobject");
function isString(s) {
    return typeof s === 'string';
}
function objToQueryString(obj) {
    return Object.keys(obj).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');
}
// JSON API standart by default
function genSortParam(obj) {
    var sortArr = [];
    Object.keys(obj).forEach(function (attr) {
        sortArr.push(((obj[attr] != 1) ? '-' : '') + attr);
    });
    return {
        key: 'sort',
        value: sortArr.join(','),
    };
}
// JSON API standart by default
function genIncludeParam(arr) {
    return {
        key: 'include',
        value: arr.join(','),
    };
}
function objAPIToQueryString(obj) {
    var resObj = {};
    if (isPlainObject(obj.filter)) {
        Object.keys(obj.filter).forEach(function (attr) {
            if (isPlainObject(obj.filter[attr])) {
                Object.keys(obj.filter[attr]).forEach(function (op) {
                    resObj["filter[" + attr + "][" + op + "]"] = obj.filter[attr][op];
                });
            }
            else {
                resObj["filter[" + attr + "]"] = obj.filter[attr];
            }
        });
    }
    if (Array.isArray(obj.include)) {
        var _a = genIncludeParam(obj.include), key = _a.key, value = _a.value;
        resObj[key] = value;
    }
    if (isPlainObject(obj.sort)) {
        var _b = genSortParam(obj.sort), key = _b.key, value = _b.value;
        resObj[key] = value;
    }
    if (isPlainObject(obj.page)) {
        if (typeof obj.page.number !== "undefined") {
            resObj["page[number]"] = obj.page.number;
        }
        if (typeof obj.page.size !== "undefined") {
            resObj["page[size]"] = obj.page.size;
        }
    }
    /*
    if (typeof obj.skip === 'numeric' && typeof obj.limit === 'numeric' && obj.limit > 0){
      resObj[ `page[size]` ] = obj.page.limit;
      resObj[ `page[number]` ] = Math.floor(obj.skip / obj.page.limit) + 1;
    }
    */
    Object.keys(obj).forEach(function (attr) {
        if (['filter', 'include', 'sort', 'page' /*, 'skip', 'limit'*/].indexOf(attr) < 0) {
            if (isPlainObject(obj[attr])) {
                Object.keys(obj[attr]).forEach(function (op) {
                    resObj[attr + "[" + op + "]"] = obj[attr][op];
                });
            }
            else {
                resObj[attr] = obj[attr].toString();
            }
        }
    });
    return objToQueryString(resObj);
}
var RestClient = /** @class */ (function () {
    function RestClient() {
        this.headers = {};
        this.baseUrl = '';
        this.genSortParam = function (obj) { return {}; };
        this.genIncludeParam = function (obj) { return []; };
        this.requestMethod = function () {
            var any = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                any[_i] = arguments[_i];
            }
        };
    }
    RestClient.prototype.config = function (_a) {
        var headers = _a.headers, baseUrl = _a.baseUrl, _b = _a.addHeaders, addHeaders = _b === void 0 ? null : _b, requestMethod = _a.requestMethod, _c = _a.genQueryStringFunctions, genQueryStringFunctions = _c === void 0 ? undefined : _c;
        if (headers) {
            this.headers = headers;
        }
        if (addHeaders) {
            this.headers = Object.assign({}, this.headers, addHeaders);
        }
        if (baseUrl) {
            this.baseUrl = baseUrl;
        }
        if (requestMethod) {
            this.requestMethod = requestMethod;
        }
        this.genSortParam = genSortParam;
        this.genIncludeParam = genIncludeParam;
        if (typeof genQueryStringFunctions === 'object') {
            if (typeof genQueryStringFunctions.genSortParam === 'function') {
                this.genSortParam = genQueryStringFunctions.genSortParam;
            }
            if (typeof genQueryStringFunctions.genIncludeParam === 'function') {
                this.genIncludeParam = genQueryStringFunctions.genIncludeParam;
            }
        }
    };
    RestClient.prototype.objAPIToQueryString = function (obj) {
        return objAPIToQueryString.bind(this)(obj);
    };
    RestClient.prototype.request = function (_a) {
        var _b = _a.url, url = _b === void 0 ? null : _b, _c = _a.baseUrl, baseUrl = _c === void 0 ? null : _c, path = _a.path, _d = _a.query, query = _d === void 0 ? undefined : _d, method = _a.method, _e = _a.headers, headers = _e === void 0 ? {} : _e, _f = _a.bodyJSObject, bodyJSObject = _f === void 0 ? undefined : _f;
        var urlFetch = url ? url : (baseUrl ? baseUrl : this.baseUrl) + path;
        query = (isPlainObject(query)) ? this.objAPIToQueryString(query) : isString(query) ? query : undefined;
        if (query) {
            urlFetch += '?' + query;
        }
        return this.requestMethod({ url: urlFetch,
            method: method,
            headers: Object.assign({}, this.headers, headers),
            bodyJSObject: bodyJSObject,
        });
    };
    RestClient.prototype.get = function (model, idOrPath, query) {
        var realPath = '';
        realPath = '/' + model + '/' + idOrPath;
        return this.request({
            path: realPath,
            query: (isPlainObject(query)) ? this.objAPIToQueryString(query) : isString(query) ? query : undefined,
            method: 'get',
        });
    };
    RestClient.prototype.post = function (model, dataOrAction, data) {
        if (data === void 0) { data = null; }
        var realPath = '';
        var realData = null;
        if (data) {
            realPath = '/' + model + '/' + dataOrAction;
            realData = data;
        }
        else {
            realPath = '/' + model;
            realData = dataOrAction;
        }
        return this.request({ path: realPath, method: 'post', bodyJSObject: realData });
    };
    RestClient.prototype.put = function (model, idOrPath, data) {
        if (data === void 0) { data = null; }
        var realPath = '';
        realPath = '/' + model + '/' + idOrPath;
        return this.request({ path: realPath, method: 'put', bodyJSObject: data });
    };
    RestClient.prototype.put_not_id = function (model, data) {
        if (data === void 0) { data = null; }
        var realPath = '';
        realPath = '/' + model;
        return this.request({ path: realPath, method: 'put', bodyJSObject: data });
    };
    RestClient.prototype.delete = function (model, idOrPath) {
        var realPath = '';
        realPath = '/' + model + '/' + idOrPath;
        return this.request({
            path: realPath,
            method: 'delete',
        });
    };
    RestClient.prototype.find = function (model, query) {
        if (query === void 0) { query = undefined; }
        var realPath = '';
        realPath = '/' + model;
        return this.request({
            path: realPath,
            query: (isPlainObject(query)) ? this.objAPIToQueryString(query) : isString(query) ? query : undefined,
            method: 'get',
        });
    };
    RestClient.prototype.findOne = function (model, id, query) {
        var realPath = '';
        realPath = '/' + model + '/' + id;
        return this.request({
            path: realPath,
            query: (isPlainObject(query)) ? this.objAPIToQueryString(query) : isString(query) ? query : undefined,
            method: 'get',
        });
    };
    RestClient.prototype.create = function (model, data) {
        return this.post(model, data);
    };
    RestClient.prototype.update = function (model, id, data) {
        return this.put(model, id, data);
    };
    RestClient.prototype.remove = function (model, id) {
        return this.delete(model, id);
    };
    return RestClient;
}());
exports.default = RestClient;
//# sourceMappingURL=index.js.map